<template>
  <div class="index-container">
    <Header></Header>
    <div class="mainbox">
      <div class="cases-container">
        <!-- 左侧案件分类 -->
        <div class="case-categories">
          <div class="category-header">
            <h3>案件分类</h3>
          </div>
          <div class="category-list">
            <div class="category-item" 
                 v-for="category in categories" 
                 :key="category.id"
                 :class="{ active: currentCategory === category.id }"
                 @click="handleCategoryClick(category)">
              <i :class="category.icon"></i>
              <span>{{ category.name }}</span>
              <span class="count">({{ category.count }})</span>
            </div>
          </div>
        </div>
        
        <!-- 右侧案件列表 -->
        <div class="case-list">
          <div class="search-box" style="padding-left: 20px;"  @change="">
                <!-- 案件状态  -->
                <el-radio-group v-model="searchstatus" size="large"  @change="statuschange">
                  <el-radio-button label="1">进行中  <span class="count" v-if="searchstatus == 1">({{ total }})</span></el-radio-button>
                  <el-radio-button label="5">已结案  <span class="count" v-if="searchstatus == 5">({{ total }})</span></el-radio-button>
                  <el-radio-button label="2">已取消 <span class="count" v-if="searchstatus == 2">({{ total }})</span></el-radio-button>
                  <el-radio-button label="">全部 <span class="count" v-if="searchstatus == 0">({{ total }})</span></el-radio-button>
                </el-radio-group>
            </div>
          <div class="list-header">
           
            <div class="filter-section">
             
              
              <div class="search-box" >
                <el-input
                  placeholder="搜索案件..."
                  v-model="searchQuery"
                  prefix-icon="el-icon-search"
                  clearable
                  @clear="handleSearch">
                 
                </el-input>
              </div>

              <div class="search-box" >
               
               <!--承办人-->
               <el-input
                  placeholder="承办人姓名"
                  v-model="searchHandler"
                  prefix-icon="el-icon-search"
                  clearable
                  @clear="handleSearch">
                  <el-button 
                    slot="append" 
                    icon="el-icon-search"
                    @click="handleSearch">
                    搜索
                  </el-button>
                </el-input>
              </div>

              <div class="filter-box">
                <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="handleDateChange">
                </el-date-picker>
              </div>


            </div>
            
            <div class="action-box">
              <el-button type="primary" icon="el-icon-plus" @click="handleAddCase">
                新增案件
              </el-button>
            </div>
          </div>
          
          <div class="list-content">
            <div v-for="item in caseList" 
                 :key="item.id" 
                 class="case-item"
                 @click="handleCaseClick(item)">
              <div class="case-basic">
                <div class="case-title">
                   ({{ item.id }}) {{ item.title }} 
                    <span>
                      <span  v-if="item.proxyType == 1" class="proxy-type1">起诉</span>
                      <span  v-if="item.proxyType == 2" class="proxy-type2">辩护</span>
                      <span  v-if="item.proxyType == 3" class="proxy-type3">调解</span>
                      <span  v-if="item.proxyType == 4" class="proxy-type4">应诉</span>
                    </span>
                    <div class="case-meta">
                      <span class="case-date">{{ item.addtime }}</span>
                      <span class="case-status processing" v-if="item.status == 1">进行中</span>
                      <span class="case-status pending" v-if="item.status == 2">已取消</span>
                      <span class="case-status completed" v-if="item.status == 5">已结案</span>
                      <span class="case-status" v-if="item.status == 0">已删除</span>
                    </div>
                    
                </div>
                <div class="case-info">
                  <span class="case-number">案号：{{ item.caseNumber }}</span>
                  <span class="case-type" :class="'a'+item.type">{{ item.typename }}</span>
                </div>
              </div>

              <div class="case-content">
                <div class="content-row">
                  <span class="label">当事人：</span>
                  <span class="value">{{ item.client }}</span>
                  <span class="label ml20">承办人：</span>
                  <span class="value">{{ item.handlername }}</span>
                  <span class="label ml20">录入人：</span>
                  <span class="value">{{ item.uname }}</span>
                  <span class="label ml20">录入时间：</span>
                  <span class="value">{{ item.add_time }}</span>
                </div>
                <!-- <div class="content-row" v-if="item.viewuid"> 
                  <span class="label">可查看：</span>
                  <span class="value">{{ item.viewname }}</span>
                </div> -->
                
                <!-- 只在审理中状态显示节点进度 -->
                <!-- <div class="content-row" v-if="item.status === 1">
                  <span class="label">当前节点：</span>
                  <span class="value">
                    <el-steps :active="item.currentStep" :space="80" simple>
                      <el-step 
                        v-for="(step, index) in item.steps" 
                        :key="index" 
                        :title="step.name">
                      </el-step>
                    </el-steps>
                  </span>
                </div>
                 -->
                <div class="content-row">
                  <span class="label">案件描述：</span>
                  <span class="value description">{{ item.description || '暂无描述' }}</span>
                </div>
              </div>

              <!-- <div class="case-meta">
                <span class="case-date">{{ item.addtime }}</span>
                <span class="case-status processing" v-if="item.status == 1">审理中</span>
                <span class="case-status pending" v-if="item.status == 2">未开始</span>
                <span class="case-status completed" v-if="item.status == 5">已结案</span>
                <span class="case-status" v-if="item.status == 0">已删除</span>
              </div> -->
            </div>
          </div>
          
          <div class="pagination-box">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增案件对话框 -->
    <el-dialog
      title="新增案件"
      :visible.sync="addCaseDialogVisible"
      width="850px"
      :close-on-click-modal="false"
      :before-close="handleDialogClose">
      <el-form :model="newCaseForm" :rules="caseFormRules" ref="caseForm" label-width="100px">
        <!-- 基本信息 -->
        <div class="form-section">
          <div class="section-title">基本信息</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="案件名称" prop="title">
                <el-input v-model="newCaseForm.title" placeholder="请输入案件名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件类型" prop="type">
                <el-select v-model="newCaseForm.type" placeholder="请选择案件类型">
                  <el-option v-for="item in cateoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="案号" prop="caseNumber">
                <el-input v-model="newCaseForm.caseNumber" placeholder="请输入案号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="承办人" prop="handler">
                <el-select v-model="newCaseForm.handler" placeholder="请选择承办人">
                  <el-option
                    v-for="item in handlers"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
         
            <el-form-item label="代理类型" prop="proxyType">
                <el-select v-model="newCaseForm.proxyType" placeholder="请选择代理类型">
                  <el-option label="起诉" value="1"></el-option>
                  <el-option label="辩护" value="2"></el-option>
                  <el-option label="调解" value="3"></el-option>
                  <el-option label="应诉" value="4"></el-option>
                </el-select>
              </el-form-item>
         
        </div>

        <!-- 当事人信息 -->
        <div class="form-section">
          <div class="section-title">当事人信息</div>
          <div class="party-info">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="当事人" prop="client">
                  <el-input v-model="newCaseForm.client" placeholder="请输入当事人姓名/单位名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="phone">
                  <el-input v-model="newCaseForm.phone" placeholder="请输入联系电话"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-model="newCaseForm.idCard" placeholder="请输入身份证号/统一社会信用代码"></el-input>
            </el-form-item>
            
            <el-form-item label="联系地址" prop="address">
              <el-input v-model="newCaseForm.address" placeholder="请输入联系地址"></el-input>
            </el-form-item>
          </div>
          

        </div>

        <div class="form-section">
          <div class="section-title">对方当事人信息</div>
          <div class="party-info">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="对方姓名" prop="defendant">
                  <el-input v-model="newCaseForm.defendant" placeholder="请输入被告姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="defendantPhone">
                  <el-input v-model="newCaseForm.defendantPhone" placeholder="请输入联系电话"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            
            <el-form-item label="身份证号" prop="defendantIdCard">
              <el-input v-model="newCaseForm.defendantIdCard" placeholder="请输入身份证号"></el-input>
            </el-form-item>
            
            <el-form-item label="联系地址" prop="defendantAddress">
              <el-input v-model="newCaseForm.defendantAddress" placeholder="请输入联系地址"></el-input>
            </el-form-item>
          </div>
        </div>

        <!-- 案件描述 -->
        <div class="form-section">
          <div class="section-title">案件描述</div>
          <el-form-item label="案件描述" prop="description">
            <el-input
              type="textarea"
              :rows="4"
              v-model="newCaseForm.description"
              placeholder="请输入案件描述">
            </el-input>
          </el-form-item>
          
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              :rows="3"
              v-model="newCaseForm.remark"
              placeholder="请输入备注信息">
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">取 消</el-button>
        <el-button type="primary" @click="submitCase" :loading="submitting">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import caseApi from '@/api/case'

export default {
  name: "Cases",
  components: {
    Header
  },
  data() {
    return {
      searchQuery: '',
      searchHandler: '',
      dateRange: '',
      searchstatus:'1',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      currentCategory: '0',
      categories: [],
      cateoptions: [],
      caseList: [
        {
          id: '1',
          title: '张三与李四房屋买卖合同纠纷案',
          caseNumber: '(2024)粤0101民初1234号',
          type: 'civil',
          typeText: '民事案件',
          status: 'processing',
          statusText: '进行中',
          createTime: '2024-03-15',
          handler: '王律师',
          client: '张三'
        }
        // ... 可以添加更多测试数据
      ],
      addCaseDialogVisible: false,
      submitting: false,
      newCaseForm: {
        title: '',
        type: '',
        caseNumber: '',
        handler: '',
        client: '',
        phone: '',
        idCard: '',
        address: '',
        description: '',//描述
        remark: '',//备注
        defendant: '',        // 被告姓名
        defendantPhone: '',   // 被告电话
        defendantIdCard: '',  // 被告身份证
        defendantAddress: '', // 被告地址
        proxyType: '', // 添加代理类型字段
      },
      handlers: [
            { value: '1', label: '张律师' },
            { value: '2', label: '李律师' },
            { value: '3', label: '王律师' }
      ],
      caseFormRules: {
        title: [
          { required: true, message: '请输入案件名称', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择案件类型', trigger: 'change' }
        ],
        // caseNumber: [
        //   { required: true, message: '请输入案号', trigger: 'blur' }
        // ],
        handler: [
          { required: true, message: '请选择承办人', trigger: 'change' }
        ],
        client: [
          { required: true, message: '请输入当事人姓名/单位名称', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入当事人电话', trigger: 'blur' },
          // { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入当事人身份证号/统一社会信用代码', trigger: 'blur' },
          // { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的当事人身份证号', trigger: 'blur' }
        ],
        // defendant: [
        //   { required: true, message: '请输入对方当事人姓名/单位名称', trigger: 'blur' }
        // ],
        // defendantPhone: [
        //   { required: true, message: '请输入对方当事人电话', trigger: 'blur' },
        //   // { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的对方当事人电话', trigger: 'blur' }
        // ],
        // defendantIdCard: [
        //   { required: true, message: '请输入对方当事人身份证号/统一社会信用代码', trigger: 'blur' },
        //   // { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的对方当事人身份证号', trigger: 'blur' }
        // ],
        proxyType: [
          { required: true, message: '请选择代理类型', trigger: 'change' }
        ]
      },
      loading: false,
    }
  },
  created() {
    this.fetchCategories();
    this.fetchCaseList();
    
  },
  methods: {


    statuschange(){
      console.log(this.searchstatus);
      this.currentPage = 1;
      this.fetchCaseList();
    },

    handleSearch() {
      // 实现搜索逻辑
      console.log('搜索:', this.searchQuery)
      this.currentPage = 1;
      this.fetchCaseList();
    },
    handleDateChange(val) {
      console.log('日期范围:', val)
      this.currentPage = 1;
      this.fetchCaseList();
    },
    handleSizeChange(val) {
      this.pageSize = val
      // 重新加载数据
      this.fetchCaseList();
    },
    handleCurrentChange(val) {
      this.currentPage = val
      // 重新加载数据
      this.fetchCaseList();
    },
    handleCategoryClick(category) {
      this.currentCategory = category.id
      // 根据分类加载案件列表
      this.fetchCaseList();
    },
    handleCaseClick(item) {
      // 跳转到案件详情页
      this.$router.push({
        path: '/cases/info',
        query: { id: item.id }
      })
    },
    handleAddCase() {
      this.addCaseDialogVisible = true;
     
      this.fetchHandlers();
      this.$nextTick(() => {
        this.$refs.caseForm && this.$refs.caseForm.resetFields()
      })
      
    },
    // 获取律师列表
    async fetchHandlers() {
      const response = await caseApi.getLawyerList();
      console.log(response);
      
      this.handlers = response.data.map(item => ({
        value: item.uid,
        label: item.real_name
      }));
      console.log(this.handlers);

    },


    handleDialogClose() {
      this.addCaseDialogVisible = false
      // this.$confirm('确认关闭？未保存的数据将会丢失', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.addCaseDialogVisible = false
      // }).catch(() => {})
    },
    
    async submitCase() {

      if(this.newCaseForm.type == '1'){
        if(this.newCaseForm.defendant == ''){
          this.$message.error('请输入对方当事人姓名/单位名称')
          return
        }
        if(this.newCaseForm.defendantPhone == ''){
          this.$message.error('请输入对方当事人电话')
          return
        }
        if(this.newCaseForm.defendantIdCard == ''){
          this.$message.error('请输入对方当事人身份证号/统一社会信用代码')
          return
        }
      }


      this.$refs.caseForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            // 调用API提交案件数据
            const response = await caseApi.createCase(this.newCaseForm)
            
            if (response.status === 200) {
              this.$message.success('案件创建成功')
              this.addCaseDialogVisible = false
              
              // 重新加载案件列表
              await this.fetchCaseList()
            } else {
              this.$message.error(response.message || '创建失败')
            }
          } catch (error) {
            this.handleError(error)
          } finally {
            this.submitting = false
          }
        }
      })
    },
    
    // 获取案件列表
    async fetchCaseList() {
      try {
        const params = {
          page: this.currentPage,
          pageSize: this.pageSize,
          category: this.currentCategory,
          keyword: this.searchQuery,
          handler: this.searchHandler,
          status: this.searchstatus,
          startDate: this.dateRange ? this.dateRange[0] : '',
          endDate: this.dateRange ? this.dateRange[1] : ''
        }
        
        const response = await caseApi.getCaseList(params)
        if (response.status === 200) {
          this.caseList = response.data.list
          this.total = response.data.total
        } else {
          this.$message.error(response.message || '获取案件列表失败')
        }
      } catch (error) {
        this.handleError(error)
      }
    },
    
    // 获取案件分类列表
    async fetchCategories() {
      this.loading = true
      try {
        const response = await caseApi.getCaseCate()
        if (response.status === 200) {
          this.categories = response.data;
          this.cateoptions = response.data.map(item => ({
            value: item.id,
            label: item.name
          }));
          //删除cateoptions中的第一个数据“全部案件”
          this.cateoptions.splice(0, 1);  
        } else {
          this.$message.error(response.message || '获取分类失败')
        }
      } catch (error) {
        this.handleError(error)
        // this.useDefaultCategories()
      } finally {
        this.loading = false
      }
    },
    
    // 使用默认分类（仅在接口失败时使用）
    useDefaultCategories() {
      this.categories = [
        { id: 'all', name: '全部案件', icon: 'el-icon-folder', count: 0 },
        { id: 'civil', name: '民事案件', icon: 'el-icon-document', count: 0 },
        { id: 'criminal', name: '刑事案件', icon: 'el-icon-warning', count: 0 },
        { id: 'administrative', name: '行政案件', icon: 'el-icon-office-building', count: 0 }
      ]
    },
    
    // 处理错误
    handleError(error) {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            this.$message.error('请先登录')
            break
          case 403:
            this.$message.error('没有权限访问')
            break
          case 404:
            this.$message.error('请求的资源不存在')
            break
          case 500:
            this.$message.error('服务器错误')
            break
          default:
            this.$message.error('请求失败')
        }
      } else if (error.request) {
        this.$message.error('网络错误，请检查网络连接')
      } else {
        this.$message.error('请求配置错误')
      }
      console.error('API Error:', error)
    }
  }
}
</script>

<style lang="less" scoped>
.cases-container {
  display: flex;
  gap: 24px;
  
  // 左侧案件分类
  .case-categories {
    width: 200px;
    flex-shrink: 0;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
    
    .category-header {
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;
      
      h3 {
        margin: 0;
        font-size: 16px;
        color: #262626;
      }
    }
    
    .category-list {
      .category-item {
        padding: 12px 16px;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: all 0.3s;
        
        &:hover {
          background: #f6f6f6;
        }
        
        &.active {
          background: #e6f7ff;
          color: #1890ff;
        }
        
        i {
          margin-right: 8px;
          font-size: 16px;
        }
        
        .count {
          margin-left: auto;
          color: #8c8c8c;
          font-size: 12px;
        }
      }
    }
  }
  
  // 右侧案件列表
  .case-list {
    flex: 1;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
    display: flex;
    flex-direction: column;
    
    .list-header {
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      
      .filter-section {
        flex: 1;
        display: flex;
        gap: 12px;
        align-items: flex-start;
        
        .search-box {
          width: 240px;  // 增加搜索框宽度
          
          :deep(.el-input__inner) {
            height: 36px;  // 增加输入框高度
            line-height: 36px;
          }
          
          :deep(.el-input-group__append) {
            background-color: #1890ff;
            border-color: #1890ff;
            color: #fff;
            padding: 0 15px;
            
            .el-button {
              border: none;
              background: transparent;
              color: #fff;
              padding: 0;
              height: 34px;  // 按钮高度适应输入框
              
              &:hover {
                background: transparent;
                opacity: 0.8;
              }
            }
          }
        }
        
        .filter-box {
          width: 360px;  // 增加日期选择器宽度
          
          :deep(.el-range-editor) {
            width: 100%;
            height: 36px;  // 增加日期选择器高度
            line-height: 36px;
            
            .el-range-input {
              height: 34px;  // 调整输入框高度
              line-height: 34px;
            }
            
            .el-range-separator {
              line-height: 32px;  // 调整分隔符位置
            }
            
            .el-range__icon,
            .el-range__close-icon {
              line-height: 34px;  // 调整图标位置
            }
          }
        }
      }
      
      .action-box {
        margin-left: 16px;
        
        .el-button {
          height: 36px;  // 增加按钮高度
          padding: 0 20px;  // 增加按钮内边距
        }
      }
    }
    
    .list-content {
      flex: 1;
      overflow-y: auto;
      padding: 16px;
      
      .case-item {
        padding: 16px;
        border: 1px solid #f0f0f0;
        border-radius: 4px;
        margin-bottom: 12px;
        cursor: pointer;
        transition: all 0.3s;
        
        &:hover {
          box-shadow: 0 2px 8px rgba(0,0,0,0.09);
        }
        
        .case-basic {
          margin-bottom: 12px;
          
          .case-title {
            font-size: 15px;
            color: #262626;
            font-weight: 500;
            margin-bottom: 8px;
          }
          
          .case-info {
            font-size: 12px;
            color: #8c8c8c;
            
            .case-number {
              margin-right: 12px;
            }
            
            .case-type {
              padding: 2px 8px;
              border-radius: 2px;
              &.a1 { background-color: #1890ff; color: #fff; }
              &.a2 { background-color: #ff4d4f; color: #fff; }
              &.a3 { background-color: #faad14; color: #fff; }
              &.a4 { background-color: #d19c22; color: #fff; }
              &.a5 { background-color: #5370e5; color: #fff; }
              &.a6 { background-color: #d57bff; color: #fff; }
            }
          }
        }
        
        .case-content {
          padding: 12px;
          background: #fafafa;
          border-radius: 4px;
          margin-bottom: 12px;
          
          .content-row {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            flex-wrap: wrap;
            
            &:last-child {
              margin-bottom: 0;
            }
            
            .label {
              color: #8c8c8c;
              margin-right: 8px;
              font-size: 13px;
            }
            
            .value {
              color: #262626;
              font-size: 13px;
              
              &.description {
                color: #595959;
                flex: 1;
                margin-right: 0;
                line-height: 1.5;
                // 文本超出两行显示省略号
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
              }
            }
            
            .ml20 {
              margin-left: 20px;
            }
            
            :deep(.el-steps) {
              flex: 1;
              
              .el-step__title {
                font-size: 12px;
              }
              
              .el-step__head {
                padding: 0 4px;
              }
            }
          }
        }
        
        .case-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          
          .case-date {
            color: #8c8c8c;
          }
          
          .case-status {
            &.processing { color: #db1923; }
            &.completed { color: #faad14; }
            &.pending { color: #8c8c8c; }
          }
        }
      }
    }
    
    .pagination-box {
      padding: 16px;
      border-top: 1px solid #f0f0f0;
      text-align: right;
    }
  }
}

// 优化新增案件表单样式
.form-section {
  position: relative;
  margin-bottom: 32px;
  padding: 24px;
  background: #fafafa;
  border-radius: 8px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  .section-title {
    font-size: 15px;
    font-weight: 500;
    color: #262626;
    margin-bottom: 24px;
    padding-left: 10px;
    border-left: 3px solid #1890ff;
  }
  
  // 表单项样式
  :deep(.el-form-item) {
    margin-bottom: 24px;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .el-form-item__label {
      font-weight: 500;
      color: #595959;
      padding-right: 16px;
    }
    
    .el-form-item__content {
      .el-input__inner,
      .el-textarea__inner {
        border-color: #e8e8e8;
        transition: all 0.3s;
        
        &:hover {
          border-color: #40a9ff;
        }
        
        &:focus {
          border-color: #1890ff;
          box-shadow: 0 0 0 2px rgba(24,144,255,0.2);
        }
      }
      
      .el-textarea__inner {
        padding: 8px 12px;
        line-height: 1.6;
      }
    }
  }
  
  // 当事人信息样式
  .party-info {
    position: relative;
    margin-bottom: 24px;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.03);
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .party-title {
      font-size: 14px;
      color: #595959;
      margin-bottom: 20px;
      padding-left: 10px;
      position: relative;
      
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 14px;
        background: #1890ff;
        border-radius: 2px;
      }
    }
  }
}

// 优化对话框样式
:deep(.el-dialog) {
  border-radius: 8px;
  overflow: hidden;
  
  .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid #f0f0f0;
    margin: 0;
    
    .el-dialog__title {
      font-size: 16px;
      font-weight: 500;
      color: #262626;
    }
  }
  
  .el-dialog__body {
    padding: 24px;
  }
  
  .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #f0f0f0;
    
    .el-button {
      padding: 0 20px;
      height: 36px;
      
      & + .el-button {
        margin-left: 12px;
      }
    }
  }
}

// 优化表单控件样式
:deep(.el-select) {
  width: 100%;
  
  .el-input__inner {
    cursor: pointer;
  }
}

:deep(.el-input-number) {
  width: 100%;
}

// 优化行间距
.el-row {
  margin-bottom: -16px;
  
  .el-col {
    margin-bottom: 16px;
  }
}

// 添加必填星号样式
:deep(.el-form-item.is-required) {
  .el-form-item__label::before {
    color: #ff4d4f;
  }
}

// 添加错误状态样式
:deep(.el-form-item.is-error) {
  .el-input__inner,
  .el-textarea__inner {
    border-color: #ff4d4f;
    
    &:focus {
      border-color: #ff4d4f;
      box-shadow: 0 0 0 2px rgba(255,77,79,0.2);
    }
  }
  
  .el-form-item__error {
    padding-top: 4px;
    font-size: 12px;
  }
}
.proxy-type1{
  color: #1890ff;
}
.proxy-type2{
  color: #ff4d4f;
}
.proxy-type3{
  color: #faad14;
}
.proxy-type4{
  color: #a99669;
}
</style>
